/**
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { createModel, type MutationsObject } from '@kp/js-model';
import { AdressData } from './AdressData';
import { BaseModel } from '../BaseModel';

export class Adressen extends BaseModel {
    eigentuemer: AdressData | null = null;
    unternehmer: AdressData | null = null;
    kontakt: AdressData | null = null;
    bevollmaechtigter: AdressData | null = null;

    public mutations(): MutationsObject {
        return {
            eigentuemer: (val: AdressData) => createModel(AdressData, val),
            unternehmer: (val: AdressData) => createModel(AdressData, val),
            kontakt: (val: AdressData) => createModel(AdressData, val),
            bevollmaechtigter: (val: AdressData) => createModel(AdressData, val),
        };
    }
}
